// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__gcDQz","icon":"SearchBar_icon__hCNMO"};